import _get from 'lodash/get';
import axios from 'axios';
import { fetchFAQIDData, receiveArticleError } from '../Article/ArticleAction';
import { receiveFormFields } from '../../../js/contactUs/actions/action-topic-data';

export const REQUEST_TOPIC_INTENT_DATA = 'REQUEST_TOPIC_INTENT_DATA';
export const RECEIVE_TOPIC_INTENT_DATA_RESPONSE = 'RECEIVE_TOPIC_INTENT_DATA_RESPONSE';
export const RECEIVE_TOPIC_INTENT_DATA_ERROR = 'RECEIVE_TOPIC_INTENT_DATA_ERROR';
export const RESET_TOPIC_INTENT_DATA = 'RESET_TOPIC_INTENT_DATA';

export const REQ_RESP_FROM_IDI = 'REQ_RESP_FROM_IDI';
export const RECEIVED_RESP_FROM_IDI = 'RECEIVED_RESP_FROM_IDI';
export const RECEIVED_IDI_CONTACT_CHANNEL_OPTIONS_ERROR = 'RECEIVED_IDI_CONTACT_CHANNEL_OPTIONS_ERROR';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export const requestTopicData = (id) => {
  return {
    type: REQUEST_TOPIC_INTENT_DATA,
    payload: { id },
  };
};

export const receiveTopicData = (responseData) => {
  const kanaCode = _get(responseData, 'formInfo.kana_code', '');
  const formElements = _get(responseData, 'formInfo.form_elements', {});

  return {
    type: RECEIVE_TOPIC_INTENT_DATA_RESPONSE,
    payload: {
      kanaCode,
      formElements,
    },
  };
};

export const receiveTopicDataError = () => {
  return {
    type: RECEIVE_TOPIC_INTENT_DATA_ERROR,
    payload: undefined,
  };
};

export const resetTopicData = () => {
  return {
    type: RESET_TOPIC_INTENT_DATA,
  };
};

export const requestResponseFromIdi = () => {
  return {
    type: REQ_RESP_FROM_IDI,
  };
};

export const receivedResponseFromIDI = (IDIChannels) => {
  return {
    type: RECEIVED_RESP_FROM_IDI,
    payload: IDIChannels,
  };
};

export const receivedIDIContactOptionsError = () => {
  return {
    type: RECEIVED_IDI_CONTACT_CHANNEL_OPTIONS_ERROR,
  };
};

/**
 * Function to fetch the form data for provided topicId
 * It also get IDI contact channels for the available kana code and topic name and pushes the data to store under key contactChannelOptionsV2
 * Also fetches the article data
 */
export const fetchTopicData = (topicId) => {
  return (dispatch) => {
    dispatch(requestTopicData(topicId));
    return axios
      .get(`/smarthelp/topic-data/?topic_id=${topicId}`, {
        cancelToken: source.token,
      })
      .then((response) => {
        dispatch(receiveTopicData(response.data));
        dispatch(receiveFormFields(response.data));
        dispatch(fetchFAQIDData(response.data));
      })
      .catch(() => {
        dispatch(receiveTopicDataError());
        dispatch(receiveArticleError());
      });
  };
};
